import { render, staticRenderFns } from "./FormWizardTitleSlot.vue?vue&type=template&id=6f4ac570"
import script from "./FormWizardTitleSlot.vue?vue&type=script&lang=js"
export * from "./FormWizardTitleSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports